const region_env = ["production", "aus_production", "eu_production", "dev"]

export default region_env